module.exports = __webpack_public_path__ + "banquet/components/Navbar/images/nav_heart.89086f714c7f6e196a167bf3ffde56c1.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/images/nav_heart.svg
// module id = 1681
// module chunks = 1